import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * 全站捲到頂：
 * - 每次 pathname 變動就 scrollTo(0,0)
 * - 若有 hash（#anchor），優先滾到對應元素
 * - 可選擇行為 smooth / instant
 * - 若你使用內層可滾動容器，傳入 selector 讓容器也回到頂端
 */
export default function ScrollToTop({ behavior = "instant", containerSelector = null }) {
    const location = useLocation();

    useEffect(() => {
        // 先處理 hash 錨點
        if (location.hash) {
        const id = decodeURIComponent(location.hash.replace("#", ""));
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
            return;
        }
        }

        // 視窗捲到頂
        try {
        window.scrollTo({ top: 0, left: 0, behavior });
        } catch {
        // 老舊瀏覽器 fallback
        window.scrollTo(0, 0);
        }

        // 若有指定可滾動容器（例如 .main-content）
        if (containerSelector) {
        const container = document.querySelector(containerSelector);
        if (container) container.scrollTop = 0;
        }
    }, [location.pathname, location.hash, behavior, containerSelector]);

    return null;
    }
